import { SELF, UPDATE_SELF, PASSWORD_UPDATE_SELF } from './HeaderActions';
import { CONTINUE_AS_GUEST } from '../Authentication/LoginActions';

import { Map } from 'immutable';

let defaultState = new Map({
  isFetching: false,
  error: false,
  data: null
});

export default function self(state = defaultState, action) {
  switch (action.type) {
    case CONTINUE_AS_GUEST:
      return Map({
        isFetching: false,
        isAuthenticated: false,
        error: false,
        data: {
          firstName: "Calhoun",
          lastName: "Guest",
          organization: {
            orgType: "GUEST"
          }
        }
      });
    case SELF.REQUEST:
    case UPDATE_SELF.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false
      }));
    case SELF.SUCCESS:
    case UPDATE_SELF.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case SELF.FAILURE:
    case UPDATE_SELF.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        data: null,
        error: action.error
      }));
    default:
      return state;
  }
}


export function passwordUpdateSelf(state = defaultState, action) {
  switch (action.type) {
    case PASSWORD_UPDATE_SELF.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false
      }));
    case PASSWORD_UPDATE_SELF.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      }));
    case PASSWORD_UPDATE_SELF.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/containers/Header/HeaderReducer.js